import { atom } from 'jotai';

import { type RewardsTabType } from '../../models';

export const rewardsSelectedTabAtom = atom<RewardsTabType>(null);
